<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li>视频短信</li>
                <li><a href="#">视频短信模板</a></li>
            </ul>
        </div>
        <div class="formbody">
            <ul class="seachform mt20">
    
                <li><label>模板主题</label><input name="" type="text" v-model="title" class="scinput" /></li>
                
                <li><label>审核结果</label>
                <div class="cityleft">
                    <!-- <select class="select2" >
                    <option value="全部">全部</option>
                    <option value="审核通过">提交审核</option>
                    <option value="审核不通过">审核不通过</option>
                    </select> -->
                    <el-select v-model="state" placeholder="请选择">
                        <el-option
                            v-for="item in stateList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                </li>
                
                <li><label>&nbsp;</label><input name="" type="button" class="scbtn" value="查询" @click="pageChange(1)"/></li>
                <!-- <li><label>&nbsp;</label><ul class="toolbar"><li style=" padding: 0 20px;">清除</li> </ul></li> -->
                
            </ul>
            <div class="tools lh33">
                <b style="font-size: 16px;">模板展示</b>
                <el-button type="primary" @click="videoTemplateAdd()">新增模板</el-button>
            </div>
            <div class="templatelist">
                <ul>                
                    <li class="listbox left" v-for="(item,index) in list">
                        <div class="blueidea">
                            <div class="blueideaimg">
                                <div v-for="item2 in item.templateContent">
                                    <ol v-if="item2.templateType == 'txt'">{{item2.templateContent}}</ol>
                                    <ol v-if="item2.templateType == 'img'"><img :src="item2.templateContent" /></ol>
                                    <ol v-if="item2.templateType == 'img'"><img :src="item2.templateContent" /></ol>
                                    <ol v-if="item2.templateType == 'img'"><img :src="item2.templateContent" /></ol>
                                </div>
                            </div>
                            <div class="blueideaspan">
                                <span class="span1">
                                    <ol v-if="item.state==3">
                                        <a href="#" @click="submitTemplate(index, item.id)"><img src="../../assets/images/ioctj.png" title="提交" /></a>
                                        <a href="#" @click="editTemplate(item.id)"><img src="../../assets/images/iocbj.png" title="编辑" /></a>
                                    </ol>
                                    <ol v-else-if="item.state==1">
                                        <!-- <a href=""><img src="../../assets/images/ioctj.png" title="复制" /></a> -->
                                        <a href=""><img src="../../assets/images/iocbj.png" title="发送" @click="sendTemplate(item.id,item.title)" /></a>
                                    </ol>
                                    <a  href="#" @click="delTemplate(item.id)"><img src="../../assets/images/iocsc.png" title="删除" /></a>
                                    <a href="#" @click="viewTemplate(index)"><img src="../../assets/images/icoyl.png" title="预览" /></a>
                                </span>
                            </div>
                        </div>
                        <div>{{item.title}}</div>
                        <div class="content">
                            <div class="left">
                                <ol v-if="item.state == 0">审核中</ol>
                                <ol v-else-if="item.state==1">审核通过</ol>
                                <ol v-else-if="item.state==2">审核不通过</ol>
                                <ol v-else-if="item.state==3">未提交</ol>
                                <ol v-else-if="item.state==4">运营商审核中</ol>
                                <ol v-else>审核不通过</ol>
                            </div>
                            <div class=" right  help-tip1">
                                <div class="helpbox">
                                    <span>模板编号： {{item.id}}</span>
                                    <span>模板主题：{{item.title}}</span>
                                    <span v-if="item.state == 0">审核结果：审核中</span>
                                    <span v-else-if="item.state == 1">审核结果：审核通过</span>
                                    <span v-else-if="item.state==3">审核结果：审核不通过</span>
                                    <span v-else-if="item.state==3">审核结果：未提交</span>
                                    <span v-else-if="item.state==4">审核结果：运营商审核中</span>
                                    <span v-else>审核结果：审核不通过</span>
                                    <span v-if="item.state==3"> 模板状态：草稿</span>
                                    <span v-else>模板状态：正常</span>
                                    <span>运营商：--</span>
                                    <span>创建时间：{{item.createTime}}</span>
                                </div>
                            </div>
                        </div>
                    </li> 
                </ul>
            </div>
            <div class="pagin">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageIndex"
                    :page-sizes="[20]"
                    :page-size="20"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount">
                </el-pagination>
            </div>
        </div>
        <!--tip1 预览-->
        <div class="tipp tip1" style="max-height:680px;">        
    	    <div class="tiptop">
                <span>模板预览</span><a></a>
            </div>        
            <div class="tipinfo cen ovhi">      
                <div class="phonediv">                                
                    <div  class="phonetop">
                        <img src="../../assets/images/phonetop.jpg" alt="top1" />
                    </div>
                    <div  class="phonebox">
                        <ul>
                            <li class="phoneboxa">
                                <div class="showDiv">
                                     <div class="phonetext">{{title}}</div>
                                </div>
                            </li>                   
                            <li v-for="(item,index2) in templateList" class="phoneboxa">
                                
                                <div class="showDiv">
                                    <div v-if="item.templateType=='txt'" class="phonetext">{{item.templateContent}}</div>
                                    <div v-else-if="item.templateType == 'img'" class="phoneimg">
                                        <img :src="item.templateContent" title="图片" >
                                    </div>
                                    <div v-else-if="item.templateType=='video'" class="phonevideo">
                                        <video :src="item.templateContent"  controls="controls" style="width: 240px;">您的浏览器不支持 video 标签。</video>
                                    </div>
                                    <div v-else-if="item.templateType=='audio'" class="phoneVF">
                                        <img :src="item.templateContent" title="音频文件" >
                                    </div>
                                </div>
                            </li>                                      
                        </ul>
                    </div> 
                </div> 
            </div>
            <div class="cen pat20 ovhi">
                <input name="" type="button"  class="cancel" @click="close()"  value="关闭" />&nbsp;
                <!-- <input name="" type="button"  class="sure" @click="close()"  value="提交审核" /> -->
            </div>    
        </div> 

        <!--tip1 end-->
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            pageIndex:0,
            totalCount:0,
            list:[],
            title:'',
            state:'',
            stateList:[{label:'未提交',value:3},{label:'审核通过',value:1},{label:'审核不通过',value:2},{label:'审核中',value:0}],
            templateList:[],
        }
    },
    mounted(){
        this.pageChange(1);
    },
    methods:{
        handleSizeChange(val) {
            this.pageChange(val);
        },
        handleCurrentChange(val) {
            this.pageChange(val);
        },
        pageChange(pageIndex){
            this.loadingShow = true;
            let that = this;
            let data = {'pageIndex':pageIndex,'pageSize':20, title:this.title,state:this.state};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/pagevideosmstemplate.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                //console.log(res);
                if('0000000' == res.data.code)
                {
                    res.data.list.map((item,index)=>{
                        
                        if(typeof item.templateContent == 'string'){
                            item.templateContent = JSON.parse(item.templateContent)
                        }
                        
                    })
                    that.list = res.data.list;
                    that.pageIndex = parseInt(pageIndex);
                    that.totalCount = res.data.page.totalCount;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        videoTemplateAdd(){
            location.href = "videosmstemplateadd";
        },
        editTemplate(id){
            location.href = "/videosmstemplateadd?id="+ id;
        },
        delTemplate(id){
            if(confirm('此操作将永久删除该条数据, 是否继续?')){
                let that = this;
                let data = {id:id};
                this.$ajax({
                    method: 'post',
                    url: this.GLOBAL.serverSrc + '/sms/delvideosmstemplate.json',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        'token' : this.GLOBAL.token
                    }
                }).then(function(res) {
                    if('0000000' == res.data.code)
                    {
                        that.$message.success("视频模板删除成功！");
                        that.pageChange(1);
                    }
                    else
                    {
                        alert(res.data.msg)
                    }
                })
            }
        },
        viewTemplate(index){
            let item = this.list[index];
            this.title = this.list[index].title;
            // console.log(this.list[index].templateContent);
            this.templateList = this.list[index].templateContent;
            $(".tip1").fadeIn(200);
            $(".tiptop a").click(function(){
                $(".tip1").fadeOut(200);
            })
        },
        submitTemplate(index, id){
            if(confirm('您确定提交审核吗？若审核通过，可使用该模板发送。')){
                let tpl = {};
                tpl = this.list[index];
                // console.log(tpl);
                let typeCount = 1;
                let typeContent = '';
                let isTxt = 0;
                let isSign = 0;
                let size = 0;
                tpl.templateContent.forEach(function(obj){
                    size = size + obj.size;
                    if(''==typeContent){
                        typeContent = obj.templateType;
                    }
                    else{
                        if(typeContent.indexOf(obj.templateType)==-1)
                        {
                            typeContent = typeContent + "," + obj.templateType;
                            typeCount++;
                        }
                    }
                    if('txt' == obj.templateType){
                        isTxt++;
                        if(obj.templateContent.indexOf('【') != -1 && obj.templateContent.indexOf('】')!=-1 && obj.templateContent.indexOf('】') > obj.templateContent.indexOf('【')){
                            isSign++;
                        }
                    }
                });
                // console.log(isTxt + ":" + isSign + ":" + size);
                if(size < 500000){
                    this.$message.error('模板大小要在500K以上');
                    return;
                }
                
                if(isTxt == 0 || isSign == 0){
                    this.$message.error('模板内容至少含有一个文本，并且含有签名！');
                    return;
                }
                if(typeCount <= 1){
                    this.$message.error('模板内容不能纯文字、纯音频、纯视频、纯图片, 至少两两组合！');
                    return;
                }
                let that = this;
                let data = {id:id};
                this.$ajax({
                    method: 'post',
                    url: this.GLOBAL.serverSrc + '/sms/submitvideosmstemplate.json',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        'token' : this.GLOBAL.token
                    }
                }).then(function(res) {
                    if('0000000' == res.data.code)
                    {
                        that.$message.success("视频模板提交成功！");
                        that.pageChange(1);
                    }
                    else
                    {
                        alert(res.data.msg)
                    }
                })
            }
        },
        close(){
            $(".tip1").fadeOut(200);
        },
        sendTemplate(id, btv){
            console.log('send id:' +id);
            // location.href = "/videosmssend?id=" + id;
            this.$router.push({
                path: '/videosmssend',   
                query: {
                    id: id,
                    btv: btv
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/sms/videosmstemplate.vue